import { render, staticRenderFns } from "./offshelf.vue?vue&type=template&id=06340d3a&"
import script from "./offshelf.vue?vue&type=script&lang=js&"
export * from "./offshelf.vue?vue&type=script&lang=js&"
import style0 from "./offshelf.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports